<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" viewBox="0 0 18 18">
  <g clip-path="url(#a)">
    <path d="M9.75 2.25A6.75 6.75 0 0 0 3 9H.75l2.917 2.918.053.105L6.75 9H4.5a5.246 5.246 0 0 1 5.25-5.25A5.246 5.246 0 0 1 15 9a5.246 5.246 0 0 1-5.25 5.25 5.208 5.208 0 0 1-3.705-1.545L4.98 13.77a6.716 6.716 0 0 0 4.77 1.98 6.75 6.75 0 0 0 0-13.5ZM9 6v3.75l3.21 1.905.54-.907-2.625-1.56V6H9Z"/>
  </g>
  <defs>
    <clipPath id="a">
      <path d="M0 0h18v18H0z"/>
    </clipPath>
  </defs>
</svg>
